module.exports = __webpack_public_path__ + "h5/img/banner4.483a5526.png";